export default function DownloadBand() {
  return (
    <section id="download" className="w-full scroll-mt-24 bg-foreground-950">
      <div className="mx-auto flex w-full max-w-[1280px] flex-col items-start justify-between gap-8 px-4 py-10 md:flex-row md:items-center md:px-6 md:py-14">
        <div className="max-w-xl">
          <span className="flex w-max items-center gap-1.5 whitespace-nowrap rounded-sm bg-accent-500 px-2 py-1 text-xs font-semibold text-foreground-950">
            <i className="ri-download-2-line" />
            客户端 · 一手推送
          </span>
          <h2 className="mt-4 font-heading text-2xl font-black leading-snug text-background-50 md:text-3xl">
            看黑料实时更新，比网页早一步
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-background-200 md:text-[15px]">
            最新黑料新爆料第一时间弹窗提醒，热点事件逐条置顶，搜索、追踪、评论区一次配齐，离线也能追更。
          </p>
          <div className="mt-6 flex flex-wrap items-center gap-3">
            <a
              href="#download"
              onClick={(e) => e.preventDefault()}
              className="flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md bg-background-50 px-4 py-2.5 text-sm font-semibold text-foreground-950 transition-colors hover:bg-background-200"
            >
              <i className="ri-apple-fill text-xl" />
              立即下载
            </a>
            <a
              href="#download"
              onClick={(e) => e.preventDefault()}
              className="flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md border border-background-300 px-4 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:border-background-100 hover:bg-background-100/10"
            >
              <i className="ri-android-fill text-xl" />
              安卓下载
            </a>
            <span className="whitespace-nowrap text-xs text-background-300">已接入 iOS / Android 全平台</span>
          </div>
        </div>

        {/* qr */}
        <div className="flex shrink-0 items-center gap-4 rounded-lg border border-background-300/40 bg-background-100/5 p-4">
          <div className="grid grid-cols-7 gap-0.5 rounded-md bg-background-50 p-2">
            {Array.from({ length: 49 }).map((_, i) => (
              <span
                key={i}
                className={`h-2 w-2 ${(i * 7 + (i % 3) * 5) % 11 < 5 ? "bg-foreground-950" : "bg-background-100"}`}
              />
            ))}
          </div>
          <div>
            <p className="flex items-center gap-1 whitespace-nowrap text-sm font-semibold text-background-50">
              <i className="ri-qr-scan-2-line text-accent-400" />
              扫码下载
            </p>
            <p className="mt-1 max-w-[130px] text-xs leading-relaxed text-background-300">
              保存二维码，用手机扫一扫即可安装客户端
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}